
import scrollTo from './../utility/scrollTo'

export default () => {

	const buttons = [...document.querySelectorAll('[data-goto-letter]')]

	buttons.map(button => {
		button.addEventListener('click', function(event) {
			const letter = event.currentTarget.getAttribute('data-goto-letter')
			const firstLetterEl = document.querySelector([`[data-letter=${letter}]`])
			if (firstLetterEl) scrollTo(firstLetterEl)
		})
	})
}